import PropTypes from 'prop-types';

import { LimitWidthStyle } from './LimitWidth.style';

const LimitWidth = ({ children, widthOnMobile, extendStyle }) => (
  <LimitWidthStyle widthOnMobile={widthOnMobile} extendStyle={extendStyle}>
    {children}
  </LimitWidthStyle>
);

LimitWidth.propTypes = {
  children: PropTypes.node.isRequired,
  widthOnMobile: PropTypes.string,
  extendStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

LimitWidth.defaultProps = {
  widthOnMobile: '',
  extendStyle: '',
};

export default LimitWidth;
